import { DependencyList, useEffect, useState } from 'react';

// Small shared fetch-on-deps-change pattern used by the per-provider dashboard stats pages —
// keeps each page's loading/error/data plumbing identical so a future provider's page is a copy
// of the same shape, not a new pattern.
export function useAsyncStat<T>(
  fetcher: () => Promise<T | null>,
  deps: DependencyList,
  errorMessage: string,
): { data: T | null; loading: boolean; error: string | null } {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetcher()
      .then((result) => {
        if (cancelled) return;
        setData(result);
      })
      .catch((e) => {
        if (cancelled) return;
        console.error(e);
        setError(errorMessage);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, deps);

  return { data, loading, error };
}
